import { render, staticRenderFns } from "./DeductionRecords.vue?vue&type=template&id=9f6e1e52&scoped=true"
import script from "./DeductionRecords.vue?vue&type=script&lang=js"
export * from "./DeductionRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6e1e52",
  null
  
)

export default component.exports